export default __webpack_public_path__ + "static/car-illustration-9b258928f31c84d071f0d766fc7a6b15.png";